import { authenticatedFetch } from '../shared/authenticatedFetch';

/**
 * In-app assignable roles. "NoAccess" is controlled by Evo Members (access on/off) and is
 * therefore never assigned through this in-app admin module.
 */
export type InAppRole = 'ReadOnly' | 'Approver' | 'Administrator';

export interface UserPermissionRecord {
  user_email: string;
  name: string;
  permissions: string[];
  created_at: string;
  updated_at: string;
}

export interface UpsertUserPermissionRequest {
  user_email: string;
  name: string;
  permissions: string[];
}

export async function getUserPermissions(apiUrl: string): Promise<UserPermissionRecord[]> {
  const response = await authenticatedFetch(`${apiUrl}/user-permissions`);
  return response.json();
}

export async function searchUserPermissions(
  apiUrl: string,
  search: string,
): Promise<UserPermissionRecord[]> {
  const response = await authenticatedFetch(
    `${apiUrl}/user-permissions?search=${encodeURIComponent(search)}`,
  );
  return response.json();
}

export async function upsertUserPermission(
  apiUrl: string,
  body: UpsertUserPermissionRequest,
): Promise<UserPermissionRecord> {
  const response = await authenticatedFetch(`${apiUrl}/user-permissions`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return response.json();
}

export async function deleteUserPermission(apiUrl: string, email: string): Promise<void> {
  await authenticatedFetch(`${apiUrl}/user-permissions/${encodeURIComponent(email)}`, {
    method: 'DELETE',
  });
}
